import { ChevronRightIcon } from 'lucide-react'
import { useContext } from 'react'

import { membersTransactions } from 'rails_routes'
import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'

import { emitBalancePillClickedEvent } from './events'

import { SessionContext } from '.'

const BalanceText = ({ showFullPrefix = false, balanceText }: { showFullPrefix: boolean, balanceText: string }) => (
  <div className='flex flex-row gap-1'>
    <p className='text-inherit font-normal'>{showFullPrefix ? 'Thatch balance:' : 'Balance:'}</p>
    <p className='text-inherit font-semibold'>{balanceText}</p>
  </div>
)

const containerClass = 'flex items-center gap-2 self-stretch text-md text-gray-800 border-color-stroke-light 2xs:px-4 2xs:py-2 2xs:rounded-[40px] 2xs:border bg-white 2xs:focus-visible:outline-thatch-500'

export const Balance = ({ showFullPrefix = true, isLink = false }: { showFullPrefix: boolean, isLink?: boolean }) => {
  const session = useContext(SessionContext)
  if (!session.isAuthenticated || !session.balance) {
    return null
  }

  const balanceString = getMinifiedLocaleCurrencyStringFromMoneyAmount(session.balance)

  return (
    isLink
      ? (
        <a
          href={membersTransactions.index()}
          onClick={() => emitBalancePillClickedEvent(session)}
          aria-label={`View your Thatch balance. Current balance: ${balanceString}`}
          className={`${containerClass} 2xs:hover:text-gray-800 2xs:hover:bg-thatch-gray-hover transition-colors duration-200 cursor-pointer no-underline`}
        >
          <BalanceText showFullPrefix={showFullPrefix} balanceText={balanceString} />
          <ChevronRightIcon aria-hidden='true' className='w-4 h-4 hover:text-thatch-500 2xs:w-5 2xs:h-5 2xs:hover:text-gray-500 2xs:text-gray-500' />
        </a>
        )
      : (
        <div className={containerClass}>
          <BalanceText showFullPrefix={showFullPrefix} balanceText={balanceString} />
        </div>
        )

  )
}
